<ng-container *transloco="let t; read: 'PASSWORD_COMPONENT'">
  <app-form-control class="mt-16 mt-32-desktop" [label]="label">
    <ion-item fill="outline">
      <ion-input
        [name]="isNewPassword ? 'new-password' : 'current-password'"
        [formControl]="passwordControl"
        [type]="showPassword ? 'text' : 'password'"
        [autocomplete]="isNewPassword ? 'new-password' : 'current-password'"
      >
      </ion-input>
      <ion-icon class="eye-icon" (click)="togglePassword()" [hidden]="showPassword" name="eye-off"> </ion-icon>
      <ion-icon class="eye-icon" (click)="togglePassword()" [hidden]="!showPassword" name="eye"> </ion-icon>
      <div class="slot-error" slot="error" *ngIf="!withValidators && passwordControl?.touched && passwordControl.hasError('required')">
        {{ t('PASSWORD_REQUIRED') }}
      </div>
    </ion-item>

    <ng-template #tplValidatorRule let-rule>
      <ion-icon
        [ngClass]="passwordControl.hasError('required') || passwordControl.hasError(rule.error) ? 'danger-color' : 'success-color'"
        [name]="passwordControl.hasError('required') || passwordControl.hasError(rule.error) ? 'close-sharp' : 'checkmark-sharp'"
      >
      </ion-icon>
      <span>{{ rule.label }}</span>
    </ng-template>

    <ul class="password-validators" *ngIf="withValidators">
      <li>
        <ng-template *ngTemplateOutlet="tplValidatorRule; context: { $implicit: { error: 'minlength', label: t('PASSWORD_MIN_LENGTH') } }"> </ng-template>
      </li>
      <li>
        <ng-template *ngTemplateOutlet="tplValidatorRule; context: { $implicit: { error: 'hasSmallCase', label: t('PASSWORD_HAS_SMALL_CASE') } }">
        </ng-template>
      </li>
      <li>
        <ng-template *ngTemplateOutlet="tplValidatorRule; context: { $implicit: { error: 'hasCapitalCase', label: t('PASSWORD_HAS_CAPITAL_CASE') } }">
        </ng-template>
      </li>
      <li>
        <ng-template *ngTemplateOutlet="tplValidatorRule; context: { $implicit: { error: 'hasNumber', label: t('PASSWORD_HAS_NUMBER') } }"> </ng-template>
      </li>
      <li>
        <ng-template
          *ngTemplateOutlet="tplValidatorRule; context: { $implicit: { error: 'hasSpecialCharacters', label: t('PASSWORD_HAS_SPECIAL_CHARACTERS') } }"
        >
        </ng-template>
      </li>
    </ul>
  </app-form-control>
</ng-container>
